<template>
  <b-modal :visible="visible" @hide="onClose" hide-footer title="Chi tiết đề thi" size="xl" centered>
    <form>
      <div class="row">
        <div class="col-md-6">
          <div class="form-group">
            <label>Mã đề</label>
            <input :value="exam.code" type="text" class="form-control" readonly />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Tên đề</label>
            <input :value="exam.name" type="text" class="form-control" readonly />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Trung tâm</label>
            <input :value="exam.center_name" type="text" class="form-control" readonly />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Khoá học</label>
            <input :value="exam.course_name" type="text" class="form-control" readonly />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Loại thi</label>
            <input :value="examTypeName" type="text" class="form-control" readonly />
          </div>
        </div>
        <div class="col-md-6">
          <div class="form-group">
            <label>Thời gian bắt đầu áp dụng</label>
            <input :value="exam.apply_from | formatDateTime" class="form-control" readonly />
          </div>
        </div>
      </div>
      <div class="d-flex justify-content-end mt-4">
        <button type="button" class="btn btn-light" @click="onClose">Đóng</button>
      </div>
    </form>
  </b-modal>
</template>

<script>
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
export default {
  name: 'MarkingExamDetailModal',
  components: { DatePicker },
  props: {
    visible: Boolean,
    examTypes: Array,
    exam: Object
  },
  computed: {
    examTypeName() {
      return this.examTypes.find(t => t.value == this.exam.exam_type)?.label || ''
    }
  },
  methods: {
    onClose() {
      this.$emit('close');
    }
  }
}
</script> 